'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function Footer() {
  return (
    <footer className="relative border-t interactive-section" style={{ borderColor: 'rgba(139,105,20,0.25)' }}>
      <div className="pixel-border-gold-top" />
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-16 relative z-10">

        {/* Tagline */}
        <div className="mb-12 max-w-2xl">
          <p className="font-mono text-sm leading-relaxed tracking-wide" style={{ color: 'rgba(245,240,232,0.5)' }}>
            A garden of caretakers, no walls, an open toolkit. Anywhere we can come to understand,
            stand on and work from. For us, by us, fisabilillah.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-start justify-between gap-10 flex-wrap">

          {/* Logo */}
          <div className="flex items-center gap-3">
            <AppLogo size={32} text="HaalProject" />
            <span className="font-mono text-xs tracking-widest uppercase" style={{ color: 'rgba(179,138,42,0.7)' }}>
              Fisabilillah
            </span>
          </div>

          {/* Foundation */}
          <nav className="flex flex-col gap-2">
            <span className="font-mono text-xs tracking-widest uppercase mb-2" style={{ color: 'rgba(139,105,20,0.6)' }}>Foundation</span>
            <Link
              href="/open-letter"
              className="font-mono text-xs transition-colors duration-200"
              style={{ color: 'rgba(196,149,106,0.85)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(224,200,120,1)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.85)'; }}
            >
              ✦ Open Letter: Deep Green
            </Link>
            {[
              { label: 'Guided Intro', href: '/guided-intro' },
              { label: 'Community', href: '/community' },
              { label: '◈ Impact Analytics', href: '/impact' },
            ]?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="font-mono text-xs transition-colors duration-200"
                style={{ color: 'rgba(245,240,232,0.35)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.9)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.35)'; }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Journey Links */}
          <nav className="flex flex-col gap-2">
            <span className="font-mono text-xs tracking-widest uppercase mb-2" style={{ color: 'rgba(139,105,20,0.6)' }}>The Journey</span>
            {[
              { label: 'Keys to Kulli Haal', href: '/keys-to-kulli-haal' },
              { label: 'Bridge: Environment Design', href: '/bridge-environment-design' },
              { label: 'Ayat in Creation', href: '/ayat-in-creation' },
              { label: 'Bridge: IRL Application', href: '/bridge-irl-application' },
              { label: 'Inner Reality Lens', href: '/inner-reality-lens' },
              { label: 'IRL Lens Walkthrough', href: '/irl-lens' },
              { label: 'Bridge: Resource Guide', href: '/bridge-resource-guide' },
              { label: 'Muslim Resource Guide', href: '/muslim-resource-guide' },
              { label: 'Names Reference', href: '/names-reference' },
            ]?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="font-mono text-xs transition-colors duration-200"
                style={{ color: 'rgba(245,240,232,0.35)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.9)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.35)'; }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Internal / Rollout */}
          <nav className="flex flex-col gap-2">
            <span className="font-mono text-xs tracking-widest uppercase mb-2" style={{ color: 'rgba(139,105,20,0.6)' }}>Rollout Phases</span>
            {[
              { label: 'Phase 1: Names Reference Alpha', href: '/phase/names-reference-alpha' },
              { label: 'Phase 2: MRG Beta', href: '/phase/mrg-beta' },
              { label: 'Phase 3: IRL Lens Pilot', href: '/phase/irl-lens-pilot' },
              { label: 'Phase 4: Full Caretaker Platform', href: '/phase/full-caretaker-platform' },
            ]?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className="font-mono text-xs transition-colors duration-200"
                style={{ color: 'rgba(245,240,232,0.25)' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.7)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.25)'; }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* ── PORTFOLIO LINK ── */}
          <nav className="flex flex-col gap-2">
            <span className="font-mono text-xs tracking-widest uppercase mb-2" style={{ color: 'rgba(139,105,20,0.6)' }}>Portfolio & Tools</span>
            <Link
              href="/portfolio/monolyth"
              className="font-mono text-xs transition-colors duration-200"
              style={{ color: 'rgba(196,149,106,0.85)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(224,200,120,1)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.85)'; }}
            >
              ◼ Monolyth (VR) Archive
            </Link>
            <Link
              href="/mana-newsletter"
              className="font-mono text-xs transition-colors duration-200"
              style={{ color: 'rgba(201,168,76,0.7)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(201,168,76,1)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(201,168,76,0.7)'; }}
            >
              ◈ MANA Newsletter Intelligence
            </Link>
            <Link
              href="/admin-dashboard"
              className="font-mono text-xs transition-colors duration-200"
              style={{ color: 'rgba(245,240,232,0.3)' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(196,149,106,0.9)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'rgba(245,240,232,0.3)'; }}
            >
              Quest Templates Admin
            </Link>
          </nav>

          {/* Copyright */}
          <div className="flex flex-col gap-2">
            <p className="font-mono text-xs" style={{ color: 'rgba(245,240,232,0.25)' }}>© 2026 The Haal Project</p>
            <p className="font-mono text-xs" style={{ color: 'rgba(139,105,20,0.5)' }}>Quran 41:53</p>
          </div>
        </div>
      </div>
    </footer>
  );
}